/******************** Hi-Fi Systems Slider ***************/


document.addEventListener("DOMContentLoaded", function () {

   var hiFiSystemSlider = new Swiper(
        ".hi-fi-systems-slider-section-content-slider-preview",
        {
          loop: true,
          spaceBetween: 10,
          slidesPerView: "auto",
          navigation: {
            nextEl: ".hi-fi-systems-slider-section-content-slider-next",
            prevEl: ".hi-fi-systems-slider-section-content-slider-prev",
          },
          watchSlidesProgress: true,
        }
      );

      var hiFiSystemSlider2 = new Swiper(
        ".hi-fi-systems-slider-section-content-slider-main",
        {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1,
          thumbs: {
            swiper: hiFiSystemSlider,
          },
          navigation: {
            nextEl: ".hi-fi-systems-slider-section-content-slider-next",
            prevEl: ".hi-fi-systems-slider-section-content-slider-prev",
          },
        }
      );

});


//<<<<Home_Cinema_Desktop_tab_start>>>>
function openTab(tabId) {
        var tabs = document.querySelectorAll('.tab-content');
        tabs.forEach(function (tab) {
            tab.classList.remove('active');
        });

        var tabButtons = document.querySelectorAll('.tab');
        tabButtons.forEach(function (button) {
            button.classList.remove('active');
        });

        document.getElementById(tabId).classList.add('active');
        document.querySelector('.tab[data-tab="' + tabId + '"]').classList.add('active');

        var dots = document.querySelectorAll('.dot');
        dots.forEach(function (dot, index) {
            dot.classList.remove('active');
            if (index === Array.from(tabs).indexOf(document.getElementById(tabId))) {
                dot.classList.add('active');
            }
        });
    }
//<<<<Home_Cinema_Desktop_tab_end>>>>

//<<<<Home_Cinema_mobile_tab_start>>>>
document.addEventListener("DOMContentLoaded", function () {
      const faqs = document.querySelectorAll('.home_cinema_mobile-faq');

      function showTab(index, otherIndex) {
        faqs.forEach((faq, i) => {
          const dots = faq.querySelectorAll('.home_cinema_mobile-dot');
          if (i === index) {
            faq.classList.add('active');
            dots[index].classList.add('active');
          } else {
            faq.classList.remove('active');
            dots[i].classList.remove('active');
          }

          if (otherIndex !== undefined && i === otherIndex) {
            dots[otherIndex].classList.remove('active');
          }
        });
      }

      faqs.forEach((faq, index) => {
        const dots = faq.querySelectorAll('.home_cinema_mobile-dot');
        dots.forEach((dot, dotIndex) => {
          dot.addEventListener('click', function () {
            showTab(dotIndex, index);
          });
        });

        faq.addEventListener('click', function () {
          showTab(index);
        });
      });

      showTab(0);
    });
//<<<<Home_Cinema_mobile_tab_end>>>>





/*============ Scroll to top js ============*/

document.addEventListener("DOMContentLoaded", function () {
  const scrollBtn = document.getElementById("scrollToTopBtn");

  window.addEventListener("scroll", () => {
    if (window.scrollY > window.innerHeight) {
      scrollBtn.classList.add("visible");
    } else {
      scrollBtn.classList.remove("visible");
    }
  });

  scrollBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
